import { type FunctionalComponent, h } from '@stencil/core';
import { ConversationalSearchLabelWithSection } from '../../../conversational-search-partials/label-with-section/label-with-section';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';
import EventEmitterComponent from '../../../conversational-search-partials/event-emitter-component/event-emitter-component';

export interface IConversationalSearchMessagesErrorAnswerFallback {
  labelProvider: labelProviderInterface;
  country: string;
  language: string;
  query: string;
}

export const ConversationalSearchMessagesErrorAnswerFallback: FunctionalComponent<
  IConversationalSearchMessagesErrorAnswerFallback
> = (props) => {
    const { labelProvider, country, language, query } = props;
    const url = `https://www.se.com/${country}/${language}/work/support/`;
    const text = labelProvider(
      'conversational.search.error.answer.fallback.message',
      'Please bear with us as we work to resolve this issue. In the meantime, feel free to ask your questions once again or please {1} ',
    );

    return (
      <div class="conversational-search-messages-error-answer-fallback">
        <strong>
          {labelProvider(
            'conversational.search.error.answer.fallback.header',
            'We\'re experiencing difficulties retrieving data at the moment.',
          )}
        </strong>
        <section class="conversational-search-messages-error-answer-fallback__cta-part">
          <ConversationalSearchLabelWithSection text={text}>
            <EventEmitterComponent
              eventName='conversational-search:ga-cta'
              ctaName='Contact Support'
              keyword={query}
              ctaLink={url}
            >
              <qds-button
                text={labelProvider(
                  'conversational.search.contact.support',
                  'Contact Support'
                )}
                href={url}
                target="_blank"
                importance="subdued"
                icon-name="chat-bubbles-square-ellipsis"
                icon-library="default"
              />
            </EventEmitterComponent>
          </ConversationalSearchLabelWithSection>
        </section>
        {labelProvider(
          'conversational.search.error.answer.fallack.outro',
          'We apologise for any inconvenience this may cause.',
        )}
      </div>
    );
};
